// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1a_UH","list":"styles_list__2zOEw"};